<template>
  <el-dialog title="发布广告" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form :model="addStoreAdsInfo" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="广告名称" prop="adName">
        <el-input v-model="addStoreAdsInfo.adName" placeholder="必填，请填写广告名称"></el-input>
      </el-form-item>
      <el-form-item label="广告类型" prop="adTypeCd">
        <el-select v-model="addStoreAdsInfo.adTypeCd" placeholder="必填，请选择广告类型" style="width:100%">
          <el-option v-for="item in addStoreAdsInfo.adTypes" :key="item.statusCd" :label="item.name"
            :value="item.statusCd">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="顺序" prop="seq">
        <el-input v-model="addStoreAdsInfo.seq" placeholder="必填，请填写顺序"></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker v-model="addStoreAdsInfo.startTime" type="datetime" placeholder="必填，请选择开始时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker v-model="addStoreAdsInfo.endTime" type="datetime" placeholder="必填，请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="链接地址">
        <el-input v-model="addStoreAdsInfo.pageUrl" placeholder="选填，请填写链接地址"></el-input>
      </el-form-item>
      <el-form-item label="广告图片" prop="imgUrl">
        <upload-image-url ref="uploadImage" :imageCount="1" @notifyUploadCoverImage="handleImageUpload">
        </upload-image-url>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveStoreAdsInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveMallAd } from '@/api/storeAds/storeAdsApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  components: {
    UploadImageUrl
  },
  data() {
    return {
      dialogVisible: false,
      addStoreAdsInfo: {
        adName: '',
        adTypeCd: '',
        seq: '',
        startTime: '',
        endTime: '',
        pageUrl: '',
        imgUrl: '',
        adTypes: [],
        shopId: ''
      },
      rules: {
        adName: [
          { required: true, message: '广告名称不能为空', trigger: 'blur' },
          { max: 128, message: '广告名称不能超过128位', trigger: 'blur' }
        ],
        adTypeCd: [
          { required: true, message: '广告类型不能为空', trigger: 'change' }
        ],
        seq: [
          { required: true, message: '顺序不能为空', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '顺序必须为正整数', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ],
        imgUrl: [
          { required: true, message: '请上传广告图片', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getDictData()
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.resetFields()
        this.$refs.uploadImage && this.$refs.uploadImage.clearImages()
      })
    },
    async getDictData() {
      try {
        const { data } = await getDict('store_ads', 'ad_type')
        this.addStoreAdsInfo.adTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleImageUpload(photos) {
      if (photos && photos.length > 0) {
        this.addStoreAdsInfo.imgUrl = photos[0]
      } else {
        this.addStoreAdsInfo.imgUrl = ''
      }
    },
    async saveStoreAdsInfo() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          let shopId = getShopId()
          this.addStoreAdsInfo.shopId = shopId
          try {
            const res = await saveMallAd(this.addStoreAdsInfo)
            if (res.code === 0) {
              this.$message.success('发布成功')
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg)
            }
          } catch (error) {
            console.error('请求失败:', error)
          }
        }
      })
    },
    handleClose() {
      this.addStoreAdsInfo = {
        adName: '',
        adTypeCd: '',
        seq: '',
        startTime: '',
        endTime: '',
        pageUrl: '',
        imgUrl: '',
        adTypes: [],
        shopId: ''
      }
    }
  }
}
</script>